
import React, { useState, useEffect } from 'react';
import { message, Button } from 'antd';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Fetchtable from '../components/Fetchtable';

const URL = process.env.REACT_APP_API_URL;

const ManagersReport = () => {

    const [reloadData, setReloadData] = useState(false);
    // const [jobPosts, setJobPosts] = useState([]);

    // useEffect(() => {
    //     const fetchJobs = async () => {
    //         const res = await fetch(`${URL}/api/getAllHiringManagers`);
    //         const data = await res.json();
    //         setJobPosts(data);   // now jobPosts is defined
    //     };

    //     fetchJobs();
    // }, []);

    // // Suppose jobPosts is your array of job objects
    // const flattenedData = jobPosts.flatMap(job =>
    //     job.panelistAndHiringManagers.map(p => ({
    //         ...p,                      // spread panelist fields
    //         position: job.position,    // keep parent job info if needed
    //         positionId: job.positionId,
    //         postedBy: job.postedBy,
    //         mgrRole: job.mgrRole,
    //         postedAt: job.postedAt
    //     }))
    // );

    // console.log('flattenedData for managers report: ', flattenedData);


    const userColumns = [
        {
            name: 'Name',
            selector: (row) => row.fullName,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.fullName}
                </div>
            ),
            sortable: true,
            width: '180px',
        },
        {
            name: 'Role',
            selector: (row) => row.role,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.role}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Department/Vertical',
            selector: (row) => row.department,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.department}
                </div>
            ),
            sortable: true,
            width: '300px',
        },
        {
            name: 'Job ID(s) Managed',
            selector: (row) => row.positionId,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.positionId}
                </div>
            ),
        },
        {
            name: 'Job Titles',
            selector: (row) => row.position,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.position}
                </div>
            ),
        },
        {
            name: 'Date Of Job Request',
            selector: (row) => row.postedAt,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {new Date(row.postedAt).toLocaleDateString()}
                </div>
            ),
        },
        {
            name: 'No. Of Interviews Scheduled',
            selector: (row) => row.interviewsScheduled,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.interviewsScheduled}
                </div>
            ),
            sortable: true,
            width: '250px',
        },
        {
            name: 'Feedback Submitted',
            selector: (row) => row.feedbackSubmitted,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.feedbackSubmitted}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Interview Feedback Awaited',
            selector: (row) => row.interviewFeedbackAwaited,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.interviewFeedbackAwaited}
                </div>
            ),
            sortable: true,
            width: '250px',
        },
        {
            name: 'Candidates Selected',
            selector: (row) => row.selected,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.selected}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Candidates Rejected',
            selector: (row) => row.rejected,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.rejected}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Offer Released',
            selector: (row) => row.offerReleasedCount,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.offerReleasedCount}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Joiners (Count)',
            selector: (row) => row.joinersCount,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.joinersCount || 0}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Last Activity Date',
            selector: (row) => new Date(row.lastActivityDate).toLocaleString(),
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {new Date(row.lastActivityDate).toLocaleString()}
                </div>
            ),
            sortable: true,
            width: '190px',
        }
    ]

    // const userColumns = [
    //     // {
    //     //     name: 'Name',
    //     //     selector: (row) => row.fullName,
    //     //     cell: (row) => (
    //     //         <div style={{ textTransform: 'capitalize' }}>
    //     //             {row.fullName}
    //     //         </div>
    //     //     ),
    //     //     sortable: true,
    //     //     width: '180px',
    //     // },
    //     {
    //         name: 'Name',
    //         selector: (row) => row.panelistAndHiringManagers.map(p => p.fullName),
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {row.panelistAndHiringManagers.map((p, i) => (
    //                     <div key={i}>{p.fullName}</div>
    //                 ))}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '180px',
    //     },
    //     {
    //         name: 'Department/Vertical',
    //         selector: (row) => row.vertical,
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {Array.isArray(row.vertical) ? row.vertical.join(', ') : row.vertical}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '300px',
    //     },
    //     // {
    //     //     name: 'Job ID(s) Managed',
    //     //     selector: (row) => row.panelistAndHiringManagers.map(p => row.assignedJobIds),
    //     //     cell: (row) => (
    //     //         <div style={{ textTransform: 'capitalize' }}>
    //     //             {row.panelistAndHiringManagers.map((p, i) => (
    //     //                 <div key={i}>{p.assignedJobIds}</div>
    //     //             ))}
    //     //         </div>
    //     //     ),
    //     //     // cell: (row) => (
    //     //     //     <div style={{ textTransform: 'capitalize' }}>
    //     //     //         {Array.isArray(row.managedJobIds) ? row.managedJobIds.join(', ') : row.managedJobIds}
    //     //     //     </div>
    //     //     // ),
    //     //     sortable: true,
    //     //     width: '190px',
    //     // },
    //     // {
    //     //     name: 'Job Titles',
    //     //     selector: (row) => row.panelistAndHiringManagers.map(p => row.position ),
    //     //     cell: (row) => (
    //     //         <div style={{ textTransform: 'capitalize' }}>
    //     //             {row.panelistAndHiringManagers.map((p, i) => (
    //     //                 <div key={i}>{row.position}</div>
    //     //             ))}
    //     //         </div>
    //     //     ),
    //     //     // cell: (row) => (
    //     //     //     <div style={{ textTransform: 'capitalize' }}>
    //     //     //         {Array.isArray(row.position) ? row.position.join(', ') : row.position}
    //     //     //     </div>
    //     //     // ),
    //     //     sortable: true,
    //     //     width: '190px',
    //     // },
    //     // {
    //     //     name: 'Date Of Job Request',
    //     //     selector: (row) => row.jobRequestedAt,
    //     //     cell: (row) => (
    //     //         <div style={{ textTransform: 'capitalize' }}>
    //     //             {new Date(row.jobRequestedAt).toLocaleString()}
    //     //         </div>
    //     //     ),
    //     //     sortable: true,
    //     //     width: '190px',
    //     // },
    //     {
    //         name: 'No. Of Interviews Scheduled',
    //         selector: (row) => row.interviewsScheduled,
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {row.interviewsScheduled}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '250px',
    //     },
    //     {
    //         name: 'Feedback Submitted',
    //         selector: (row) => row.feedbackSubmitted,
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {row.feedbackSubmitted}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '190px',
    //     },
    //     {
    //         name: 'Interview Feedback Awaited',
    //         selector: (row) => row.interviewFeedbackAwaited,
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {row.interviewFeedbackAwaited}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '250px',
    //     },
    //     {
    //         name: 'Candidates Selected',
    //         selector: (row) => row.rejected,
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {row.rejected}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '190px',
    //     },
    //     {
    //         name: 'Candidates Rejected',
    //         selector: (row) => row.selected,
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {row.selected}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '190px',
    //     },
    //     {
    //         name: 'Joiners (Count)',
    //         selector: (row) => row.join,
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {row.join}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '190px',
    //     },
    //     {
    //         name: 'Last Activity Date',
    //         selector: (row) => new Date(row.lastActivityDate).toLocaleString(),
    //         cell: (row) => (
    //             <div style={{ textTransform: 'capitalize' }}>
    //                 {new Date(row.lastActivityDate).toLocaleString()}
    //             </div>
    //         ),
    //         sortable: true,
    //         width: '190px',
    //     }
    // ]
    return (
        <>
            <div>
                <br /><br /><br /><br /><br /><br />
                <h1>Welcome to Managers's Report Tab</h1>
                <Fetchtable
                    url={`${URL}/api/getAllHiringManagers`}
                    columns={userColumns}
                    // setSelectedCandidate={setSelectedCandidate}
                    reloadData={reloadData}
                    fileName="Managers' Report"
                // filterOption={filterOption}
                />
            </div>
        </>
    )

}

export default ManagersReport;